import services from '../services'
import * as types from './mutation-types'

export const getList = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_PUBLIC_QUESTIONS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.find(id).then(res => {
    commit(types.SET_PUBLIC_QUESTION, res.data.data)
  })
}

export const updateStatus = async ({ commit }, obj) => {
  await services.updateStatus(obj).then(res => {
    return res
  })
}

export const deletePublicQuestion = async ({ commit }, obj) => {
  await services.deletePublicQuestion(obj).then(res => {
    return res
  })
}
